// @flow
import { updateForm } from "../_modularui/ModularUIActions";

import type FormModel from "../../models/form/FormModel";
import type FormObjectModel from "../../models/form/FormObjectModel";
import type { UpdateFormAction } from "../_modularui/types";

/**
 */
export const addRepeatableAttributeSet = (
  form: FormModel,
): UpdateFormAction => {
  const newForm = form.clone();

  newForm.addEmptyFormObject();

  return updateForm(newForm);
};

/**
 */
export const cancelRepeatableAttributeSet = (
  form: FormModel,
  formObject: FormObjectModel,
): UpdateFormAction => {
  const newForm = form.clone();

  newForm.addEmptyFormObject();
  newForm.removeFormObject(formObject);

  return updateForm(newForm);
};

/**
 */
export const removeRepeatableAttributeSet = (
  form: FormModel,
  formObject: FormObjectModel,
): UpdateFormAction => {
  const newForm = form.clone();

  newForm.removeFormObject(formObject);

  return updateForm(newForm);
};
